<template>
<BasePanel
        headline="lang_LABEL_TRACKS_CAPTION_MEDIA"
        :alvqa="alvqa"
    >

        <template v-slot:panelContent>
            
            <v-data-table
                :headers="headers"
                :items="listItems"
                hide-default-footer
                :header-props="{ sortIcon: '' }"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
            >

            <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

            <!-- FOR VISUAL  -->
                <template v-slot:[`item.media`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-media'">
                        {{
                            item.name
                        }}
                    </div>
                </template>
            
            <!-- ICON -->
                <template v-slot:[`item.playTrack`]="{ item }">   
                        <BaseIcon 
                            v-if="item.type === 'mp3' "
                            @click.stop="play(item)"
                            :alvqa="alvqa + '-media-read-only-icon-audio'"
                            :icon="item.isPlaying ? 'fa-stop-circle' : 'fa-play-circle'"
                            :tooltipText="item.isPlaying ? 'lang_GENERAL_CAPTION_STOP' : 'lang_GENERAL_CAPTION_PLAY'"   
                        />
                </template>
                <template v-slot:[`item.downloadLink`]="{ item }">
                        <!-- Get path from BE -->
                        <BaseIcon 
                            @click.stop="downloadFile(item.link)"
                            :alvqa="alvqa + '-list-row-icon-donwload'"                        
                            icon="cloud_download"
                            tooltipText="lang_GENERAL_CAPTION_ICON_DOWNLOAD"
                        />
                </template>
            </v-data-table>
        </template>
</BasePanel>
  
</template>

<script>

import BasePanel from '@/components/_base/BasePanel'
import BaseIcon from '@/components/_buttons/BaseIcon'
import api from '@/api_alv'

export default {
    name: "TracksMediaReadOnlyPanel",

    components: { 
        BasePanel,
        BaseIcon
    },

    props:{
        trackAlvId: {
            type: String
        }
    },

    data(){
        return{
            alvqa: 'label-tracks-list-row-' + this.trackAlvId + 'read-only-panel-media',
            trackIcon:''
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t("lang_LABEL_SALES_DATA_CAPTION_FILE_NAME"), 
                    align: "left", 
                    value: "media",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-artist'
                },
                {
                    text: '', 
                    value: 'playTrack',
                    align: 'right',
                    sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
                },
                {
                    text: '', 
                    value: 'downloadLink',
                    align: 'right',
                    sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
                }
            ]
        },

        listItems() { 
            return this.$store.getters.getTracksMedia
        },

        globalAudio: {
            get() { return this.$store.getters['getAudio'] },
            set(item) { this.$store.commit('setAudio', item) }
        }
    },
    methods:{
        downloadFile(path) {
            api.getFileFromALV(path)
        },

               /*
            Function triggered on clicking 'play' icon in track list
            item.isPlaying is used for icon and tooltip text change. Added after fetching data from backend
            this.globalAudio is used for creating Audioi() object and playing/pausing audio. From $store
        */
        play (item) { 
            // if audio is playing but not clicked one
            // stop playing and set isPlaying property for found track to false 
            if(this.globalAudio != null  && !item.isPlaying) { 
                this.globalAudio.pause();
                this.globalAudio = null;
                let index = this.listItems.findIndex(track =>{
                    return track.isPlaying === true
                }
                );
                this.listItems[index].isPlaying = false;
            }

            // if audio is not playing (null)
            // create, add event, change isPlaying to true and play audio
            // else
            // pause current track, set global property to null and change isPlaying
            if(this.globalAudio == null) {
                this.globalAudio = new Audio(item.link);
                this.globalAudio.addEventListener('ended', this.endedAudioEvent.bind(event, item));
                item.isPlaying = true
                this.globalAudio.play()
            } else {
                this.globalAudio.pause()
                item.isPlaying = false
                this.globalAudio = null
            }
        },
        endedAudioEvent(item) {
            item.isPlaying = false
            this.globalAudio = null
        },
    } 

}
</script>

<style>

</style>